// // import React, { useState, useEffect } from "react";
// // import { NavLink } from "react-router-dom";
// // import { URLS } from "../Url";
// // import axios from "axios";
// // import footerLogo from "./carnival_footer_logo-1-removebg-preview.png";
// // import logo from "../components/carnival_footer_logo-2-removebg-preview.png";
// // function Footer() {
// //   const [Contact, setContact] = useState([]);

// //   useEffect(() => {
// //     GetFooterData();
// //   }, []);

// //   const GetFooterData = () => {
// //     axios.post(URLS.GetFooter, {}, {}).then((res) => {
// //       if (res.status === 200) {
// //         setContact(res.data.contactus);
// //       }
// //     });
// //   };

// //   return (
// //     <div>
// //       {" "}
// //       <footer className="footer footersix bg-black">
// //         <div className="footer-top">
// //           <div className="container-md">
// //             <div className="row">
// //               <div className="col-lg-5 col-md-6">
// //                 <div className="footer-widget footer-about">
// //                   <h2 className="footer-title">
// //                     {" "}
// //                     <img
// //                       // src={URLS.Base + Contact.logo}
// //                       // src={footerLogo}
// //                       src={logo}
// //                       alt="logo"
// //                       style={{ height: "100px" }}
// //                     />
// //                   </h2>
// //                   <div className="footer-about-content">
// //                     <p>{Contact.description}</p>
// //                     <div className="social-icon">
// //                       <ul>
// //                         <li>
// //                           <a
// //                             href="https://www.facebook.com/carnivalcastlehyderabad?_rdr"
// //                             target="_blank"
// //                             rel="noopener noreferrer"
// //                           >
// //                             <i className="fab fa-facebook-f" />{" "}
// //                           </a>
// //                         </li>

// //                         {/* <li>
// //                           <a
// //                             // href="#"
// //                             target="_blank"
// //                             className="twitter-icon" 
// //                           >
// //                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="14px"><path fill="black" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
// //                           </a>
// //                         </li> */}
// //                         <li>
// //                           <a
// //                             href="https://www.youtube.com/@Carnival_Castle"
// //                             target="_blank"
// //                           >
// //                             <i className="fab fa-youtube" />
// //                           </a>
// //                         </li>
// //                         {/* <li>
// //                           <a href={Contact.linkedin} target="_blank">
// //                             <i className="fab fa-linkedin-in" />
// //                           </a>
// //                         </li> */}
// //                         <li>
// //                           <a
// //                             href="https://www.instagram.com/carnival_castle_hyderabad/"
// //                             target="_blank"
// //                           >
// //                             <i className="fab fa-instagram" />
// //                           </a>
// //                         </li>
// //                         <li>
// //                           <a
// //                             href={`https://wa.me/${Contact.phone}`}
// //                             target="_blank"
// //                             rel="noopener noreferrer"
// //                           >
// //                             <i className="fab fa-whatsapp" />
// //                           </a>
// //                         </li>
// //                       </ul>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //               <div className="col-lg-2 col-md-6 ">
// //                 <div className="footer-widget footer-menu">
// //                   <h2 className="footer-title text-white">Quick Links</h2>
// //                   <ul>
// //                     <li>
// //                       <NavLink to="/" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Home
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/about" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         About
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/theaters" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Theaters
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/cakes" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Cake's
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       {" "}
// //                       <NavLink to="/enquiry" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Enquiry
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/Faqs" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Faq's
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/blogs" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Blogs
// //                       </NavLink>
// //                     </li>
// //                     <li>
// //                       <NavLink to="/gallery" style={{ color: "white" }}>
// //                         <i
// //                           className="fas fa-angle-double-right"
// //                           style={{ paddingRight: "5px" }}
// //                         />
// //                         Gallery
// //                       </NavLink>
// //                     </li>
// //                   </ul>
// //                 </div>
// //               </div>
// //               <div className="col-lg-5 col-md-6">
// //                 <div className="footer-widget footer-contact ">
// //                   <h2 className="footer-title text-white">Address</h2>
// //                   <div className="footer-contact-info">
// //                     <div className="footer-address">
// //                       <span>
// //                         <i className="fas fa-map-marker-alt" />
// //                       </span>
// //                       <p>{Contact.address}</p>
// //                     </div>
// //                     <p>
// //                       <i className="fas fa-phone-alt" />
// //                       <a
// //                         href={`tel:+91${Contact.phone}`}
// //                         className="text-white"
// //                       >
// //                         +91 {Contact.phone} (Whatsapp only)
// //                       </a>
// //                     </p>
// //                     <p className="mb-0">
// //                       <i className="fas fa-envelope" />
// //                       <a
// //                         href={`mailto:${Contact.email}`}
// //                         className="text-white footer-mail"
// //                       >
// //                         {Contact.email}
// //                       </a>
// //                     </p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //         <div className="footer-bottom">
// //           <div className="container-md">
// //             <div className="copyright">
// //               <div className="row">
// //                 <div className="col-md-7 col-lg-6">
// //                   <div className="copyright-text">
// //                     <ul className="policy-menu text-start d-flex">
// //                       <li>
// //                         <NavLink to="/Terms" style={{ color: "white" }}>
// //                           Terms and Conditions
// //                         </NavLink>
// //                       </li>
// //                       <li>
// //                         <NavLink to="/PrivacyPolicy" style={{ color: "white" }}>
// //                           Privacy Policy
// //                         </NavLink>
// //                       </li>
// //                       <li>
// //                         <NavLink to="/RefundPolicy" style={{ color: "white" }}>
// //                           Refund Policy
// //                         </NavLink>
// //                       </li>
// //                     </ul>
// //                   </div>
// //                 </div>
// //                 <div className="col-md-5 col-lg-6">
// //                   <div className="copyright-menu">
// //                     <ul className="policy-menu">
// //                       <li>
// //                         <p className="mb-0">
// //                           © 2024. Carnival Castle. All Rights Reserved.
// //                           {/* Designed by{" "}
// //                           <a
// //                             href="https://digitalraiz.com/"
// //                             target="_blank"
// //                             className="company-name"
// //                             style={{ color: "white" }}
// //                           >
// //                             Digitalraiz
// //                           </a> */}
// //                         </p>
// //                       </li>
// //                     </ul>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //         {/*
// //         <section
// //           className="py-4"
// //           style={{ backgroundColor: "#8c8c8c", borderRadius: "12px" }}
// //         >
// //           <div className="container">
// //             <div className="row align-items-center">

              
// //               <div className="col-md-6 text-white">
// //                 <h5 className="fw-bold mb-1">Subscribe to Our Newsletter</h5>
// //                 <p className="mb-0">
// //                   Get updates on latest offers and celebration inspiration.
// //                 </p>
// //               </div>

              
// //               <div className="col-md-6 mt-3 mt-md-0">
// //                 <form className="d-flex">
// //                   <input
// //                     type="email"
// //                     className="form-control me-2"
// //                     placeholder="Your Email Address"
// //                     style={{
// //                       backgroundColor: "#777",
// //                       color: "white",
// //                       border: "none",
// //                       borderRadius: "6px",
// //                     }}
// //                   />
// //                   <button
// //                     className="btn btn-light fw-bold"
// //                     type="submit"
// //                     style={{ borderRadius: "6px" }}
// //                   >
// //                     Subscribe
// //                   </button>
// //                 </form>
// //               </div>

// //             </div>
// //           </div>
// //         </section>
// //         */}


// //       </footer>
// //     </div>
// //   );
// // }

// // export default Footer;
// import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import {
//   FaFacebookF,
//   FaYoutube,
//   FaInstagram,
//   FaWhatsapp,
// } from "react-icons/fa";
// import { URLS } from "../Url";
// import axios from "axios";
// import footerLogo from "./carnival_footer_logo-1-removebg-preview.png";
// import logo from "../components/carnival_footer_logo-2-removebg-preview.png";

// // ── Colour tokens ─────────────────────────────────────────────────────────────
// const C = {
//   ink:       "#0d0414",
//   purple:    "#1a0533",
//   purpleMid: "#2d0a52",
//   violet:    "#9D4DFF",
//   gold:      "#FFD700",
//   goldLight: "#FFE566",
//   goldDim:   "rgba(255,215,0,0.12)",
//   goldBorder:"rgba(255,215,0,0.22)",
//   white:     "#ffffff",
//   offWhite:  "rgba(255,255,255,0.82)",
//   muted:     "rgba(255,255,255,0.42)",
//   divider:   "rgba(255,215,0,0.15)",
// };

// const quickLinks = [
//   { to: "/",            label: "Home" },
//   { to: "/about",       label: "About" },
//   { to: "/theaters",    label: "Theaters" },
//   { to: "/cakes",       label: "Cakes" },
//   { to: "/enquiry",     label: "Enquiry" },
//   { to: "/Faqs",        label: "FAQs" },
//   { to: "/blogs",       label: "Blogs" },
//   { to: "/gallery",     label: "Gallery" },
// ];

// const policies = [
//   { to: "/Terms",        label: "Terms & Conditions" },
//   { to: "/PrivacyPolicy",label: "Privacy Policy" },
//   { to: "/RefundPolicy", label: "Refund Policy" },
// ];

// function Footer() {
//   const [Contact, setContact] = useState({});

//   useEffect(() => {
//     axios.post(URLS.GetFooter, {}, {}).then((res) => {
//       if (res.status === 200) setContact(res.data.contactus);
//     });
//   }, []);

//   return (
//     <footer style={styles.footer}>
//       {/* ── Gold shimmer top border ── */}
//       <div style={styles.topBorder} />

//       {/* ── Radial glow backdrop ── */}
//       <div style={styles.glowLeft}  aria-hidden="true" />
//       <div style={styles.glowRight} aria-hidden="true" />

//       {/* ═══════════════════════════════════════════════
//           MAIN BODY
//       ═══════════════════════════════════════════════ */}
//       <div style={styles.body}>
//         <div className="container-md">
//           <div className="row g-5">

//             {/* ── Col 1: Brand ─────────────────────────── */}
//             <div className="col-lg-5 col-md-6">
//               <div style={styles.brandCol}>
//                 <img src={logo} alt="Carnival Castle" style={styles.logo} />

//                 <p style={styles.brandDesc}>
//                   {Contact.description ||
//                     "Hyderabad's most celebrated private theatre experience — where every moment becomes a memory worth keeping."}
//                 </p>

//                 {/* Social row */}
//                 <div style={styles.socialRow}>
//                   {[
//                     { href: "https://www.facebook.com/carnivalcastlehyderabad?_rdr", icon: <FaFacebookF />, label: "Facebook" },
//                     { href: "https://www.youtube.com/@Carnival_Castle",              icon: <FaYoutube />,    label: "YouTube"  },
//                     { href: "https://www.instagram.com/carnival_castle_hyderabad/",  icon: <FaInstagram />,  label: "Instagram"},
//                     { href: `https://wa.me/${Contact.phone}`,                        icon: <FaWhatsapp />,   label: "WhatsApp" },
//                   ].map(({ href, icon, label }) => (
//                     <a key={label} href={href} target="_blank" rel="noopener noreferrer"
//                       aria-label={label} style={styles.socialIcon}
//                       onMouseEnter={e => {
//                         e.currentTarget.style.background = C.gold;
//                         e.currentTarget.style.color      = C.ink;
//                         e.currentTarget.style.transform  = "translateY(-3px)";
//                       }}
//                       onMouseLeave={e => {
//                         e.currentTarget.style.background = C.goldDim;
//                         e.currentTarget.style.color      = C.gold;
//                         e.currentTarget.style.transform  = "translateY(0)";
//                       }}>
//                       <i className={icon} />
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* ── Col 2: Quick Links ────────────────────── */}
//             <div className="col-lg-2 col-md-6 col-6">
//               <div style={styles.colWrap}>
//                 <ColTitle>Quick Links</ColTitle>
//                 <ul style={styles.linkList}>
//                   {quickLinks.map(({ to, label }) => (
//                     <li key={to} style={{ marginBottom: 10 }}>
//                       <NavLink to={to} style={styles.navLink}
//                         onMouseEnter={e => {
//                           e.currentTarget.style.color       = C.gold;
//                           e.currentTarget.style.paddingLeft = "10px";
//                         }}
//                         onMouseLeave={e => {
//                           e.currentTarget.style.color       = C.offWhite;
//                           e.currentTarget.style.paddingLeft = "0";
//                         }}>
//                         <span style={styles.linkArrow}>›</span>
//                         {label}
//                       </NavLink>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>

//             {/* ── Col 3: Contact ────────────────────────── */}
//             <div className="col-lg-5 col-md-12">
//               <div style={styles.colWrap}>
//                 <ColTitle>Get In Touch</ColTitle>

//                 <div style={styles.contactBlock}>
//                   <ContactItem icon="fas fa-map-marker-alt">
//                     {Contact.address || "Hyderabad, Telangana, India"}
//                   </ContactItem>
//                   <ContactItem icon="fas fa-phone-alt">
//                     <a href={`tel:+91${Contact.phone}`} style={styles.contactLink}>
//                       +91 {Contact.phone}
//                       <span style={{ color: C.muted, fontSize: 11, marginLeft: 6 }}>(WhatsApp only)</span>
//                     </a>
//                   </ContactItem>
//                   <ContactItem icon="fas fa-envelope">
//                     <a href={`mailto:${Contact.email}`} style={styles.contactLink}>
//                       {Contact.email}
//                     </a>
//                   </ContactItem>
//                 </div>

//                 {/* CTA chip */}
//                 <a href={`https://wa.me/${Contact.phone}`} target="_blank" rel="noopener noreferrer"
//                   style={styles.ctaChip}
//                   onMouseEnter={e => { e.currentTarget.style.background = C.gold; e.currentTarget.style.color = C.ink; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.gold; }}>
//                   <i className="fab fa-whatsapp" style={{ marginRight: 8, fontSize: 16 }} />
//                   Book on WhatsApp
//                 </a>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* ── Gold divider ── */}
//       <div style={styles.divider} />

//       {/* ═══════════════════════════════════════════════
//           FOOTER BOTTOM
//       ═══════════════════════════════════════════════ */}
//       <div style={styles.bottom}>
//         <div className="container-md">
//           <div style={styles.bottomInner}>

//             {/* Policy links */}
//             <div style={styles.policyRow}>
//               {policies.map(({ to, label }, i) => (
//                 <React.Fragment key={to}>
//                   <NavLink to={to} style={styles.policyLink}
//                     onMouseEnter={e => e.currentTarget.style.color = C.gold}
//                     onMouseLeave={e => e.currentTarget.style.color = C.muted}>
//                     {label}
//                   </NavLink>
//                   {i < policies.length - 1 && (
//                     <span style={{ color: C.divider, margin: "0 10px" }}>|</span>
//                   )}
//                 </React.Fragment>
//               ))}
//             </div>

//             {/* Copyright */}
//             <p style={styles.copyright}>
//               © {new Date().getFullYear()}&nbsp;
//               <span style={{ color: C.gold, fontWeight: 700 }}>Carnival Castle</span>.
//               &nbsp;All Rights Reserved.
//             </p>

//           </div>
//         </div>
//       </div>

//       <Styles />
//     </footer>
//   );
// }

// // ── Small helpers ─────────────────────────────────────────────────────────────

// const ColTitle = ({ children }) => (
//   <div style={{ marginBottom: 24 }}>
//     <h3 style={{
//       fontFamily: "'Playfair Display', serif",
//       fontSize: 18, fontWeight: 800, color: C.white,
//       margin: "0 0 10px", letterSpacing: 0.4,
//     }}>
//       {children}
//     </h3>
//     <div style={{ width: 36, height: 2, background: `linear-gradient(90deg, ${C.gold}, transparent)` }} />
//   </div>
// );

// const ContactItem = ({ icon, children }) => (
//   <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 18 }}>
//     <div style={{
//       width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
//       background: C.goldDim, border: `1px solid ${C.goldBorder}`,
//       display: "flex", alignItems: "center", justifyContent: "center",
//     }}>
//       <i className={icon} style={{ color: C.gold, fontSize: 13 }} />
//     </div>
//     <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13.5,
//       color: C.offWhite, lineHeight: 1.6, paddingTop: 6 }}>
//       {children}
//     </div>
//   </div>
// );

// // ── Inline styles ─────────────────────────────────────────────────────────────

// const styles = {
//   footer: {
//     background: `linear-gradient(175deg, ${C.purpleMid} 0%, ${C.purple} 45%, ${C.ink} 100%)`,
//     position: "relative",
//     overflow: "hidden",
//     fontFamily: "'DM Sans', sans-serif",
//   },
//   topBorder: {
//     height: 2,
//     background: `linear-gradient(90deg, transparent 0%, ${C.gold} 30%, ${C.goldLight} 50%, ${C.gold} 70%, transparent 100%)`,
//   },
//   glowLeft: {
//     position: "absolute", top: 0, left: "-10%",
//     width: 500, height: 500, borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(157,77,255,0.18) 0%, transparent 70%)",
//     pointerEvents: "none",
//   },
//   glowRight: {
//     position: "absolute", bottom: 0, right: "-10%",
//     width: 400, height: 400, borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(255,215,0,0.08) 0%, transparent 70%)",
//     pointerEvents: "none",
//   },
//   body: {
//     padding: "64px 0 48px",
//     position: "relative", zIndex: 1,
//   },
//   brandCol: {
//     display: "flex", flexDirection: "column", gap: 0,
//   },
//   logo: {
//     height: 90, objectFit: "contain", objectPosition: "left",
//     marginBottom: 20,
//   },
//   brandDesc: {
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 13.5, color: C.muted, lineHeight: 1.75,
//     maxWidth: 360, marginBottom: 24,
//   },
//   socialRow: {
//     display: "flex", gap: 10,
//   },
//   socialIcon: {
//     width: 38, height: 38, borderRadius: "50%",
//     background: C.goldDim, border: `1px solid ${C.goldBorder}`,
//     color: C.gold, display: "flex", alignItems: "center",
//     justifyContent: "center", fontSize: 14,
//     textDecoration: "none", transition: "all 0.25s ease",
//   },
//   colWrap: {
//     paddingTop: 4,
//   },
//   linkList: {
//     listStyle: "none", margin: 0, padding: 0,
//   },
//   navLink: {
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 13.5, color: C.offWhite,
//     textDecoration: "none", display: "flex",
//     alignItems: "center", gap: 8,
//     transition: "all 0.2s ease",
//   },
//   linkArrow: {
//     color: C.gold, fontSize: 18, lineHeight: 1, flexShrink: 0,
//   },
//   contactBlock: {
//     marginBottom: 24,
//   },
//   contactLink: {
//     color: C.offWhite, textDecoration: "none",
//     transition: "color 0.2s",
//   },
//   ctaChip: {
//     display: "inline-flex", alignItems: "center",
//     padding: "10px 22px", borderRadius: 30,
//     border: `1.5px solid ${C.gold}`,
//     color: C.gold, background: "transparent",
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 13, fontWeight: 700,
//     letterSpacing: 0.5, textDecoration: "none",
//     transition: "all 0.25s ease",
//   },
//   divider: {
//     height: 1,
//     background: `linear-gradient(90deg, transparent, ${C.goldBorder} 30%, ${C.goldBorder} 70%, transparent)`,
//     margin: "0 24px",
//   },
//   bottom: {
//     padding: "20px 0",
//     position: "relative", zIndex: 1,
//   },
//   bottomInner: {
//     display: "flex", flexWrap: "wrap",
//     alignItems: "center", justifyContent: "space-between",
//     gap: 12,
//   },
//   policyRow: {
//     display: "flex", flexWrap: "wrap",
//     alignItems: "center", gap: 2,
//   },
//   policyLink: {
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 12, color: C.muted,
//     textDecoration: "none",
//     transition: "color 0.2s ease",
//     whiteSpace: "nowrap",
//   },
//   copyright: {
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 12.5, color: C.muted,
//     margin: 0,
//   },
//   socialIcon: {
//   width: 42,
//   height: 42,
//   borderRadius: "50%",
//   background: C.goldDim,
//   border: `1px solid ${C.goldBorder}`,
//   color: C.gold,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontSize: 17,
//   textDecoration: "none",
//   transition: "all 0.25s ease",
// },
// };

// // ── Global micro-styles ───────────────────────────────────────────────────────
// const Styles = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=DM+Sans:wght@400;500;700&display=swap');

//     footer a:hover { text-decoration: none !important; }

//     @media (max-width: 767px) {
//       .footer-bottom-inner { flex-direction: column; text-align: center; }
//     }
//   `}</style>
// );

// export default Footer;

// export default Footer;
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { URLS } from "../Url";
import axios from "axios";
import footerLogo from "./carnival_footer_logo-1-removebg-preview.png";
import logo from "../components/carnival_footer_logo-2-removebg-preview.png";

// ── Colour tokens ─────────────────────────────────────────────────────────────
const C = {
  ink:       "#0d0414",
  purple:    "#1a0533",
  purpleMid: "#2d0a52",
  violet:    "#9D4DFF",
  gold:      "#FFD700",
  goldLight: "#FFE566",
  goldDim:   "rgba(255,215,0,0.12)",
  goldBorder:"rgba(255,215,0,0.22)",
  white:     "#ffffff",
  offWhite:  "rgba(255,255,255,0.82)",
  muted:     "rgba(255,255,255,0.42)",
  divider:   "rgba(255,215,0,0.15)",
};

const quickLinks = [
  { to: "/",            label: "Home" },
  { to: "/about",       label: "About" },
  { to: "/theaters",    label: "Theaters" },
  { to: "/cakes",       label: "Cakes" },
  { to: "/enquiry",     label: "Enquiry" },
  { to: "/Faqs",        label: "FAQs" },
  { to: "/blogs",       label: "Blogs" },
  { to: "/gallery",     label: "Gallery" },
];

const policies = [
  { to: "/Terms",        label: "Terms & Conditions" },
  { to: "/PrivacyPolicy",label: "Privacy Policy" },
  { to: "/RefundPolicy", label: "Refund Policy" },
];

function Footer() {
  const [Contact, setContact] = useState({});

  useEffect(() => {
    axios.post(URLS.GetFooter, {}, {}).then((res) => {
      if (res.status === 200) setContact(res.data.contactus);
    });
  }, []);

  return (
    <footer style={styles.footer}>
      {/* ── Gold shimmer top border ── */}
      <div style={styles.topBorder} />

      {/* ── Gold gradient accent bar ── */}
      <div style={styles.goldAccent} />

      {/* ── Radial glow backdrop ── */}
      <div style={styles.glowLeft}  aria-hidden="true" />
      <div style={styles.glowRight} aria-hidden="true" />

      {/* ═══════════════════════════════════════════════
          MAIN BODY
      ═══════════════════════════════════════════════ */}
      <div style={styles.body}>
        <div className="container-md">
          <div className="row g-5">

            {/* ── Col 1: Brand ─────────────────────────── */}
            <div className="col-lg-5 col-md-6">
              <div style={styles.brandCol}>
                <img src={logo} alt="Carnival Castle" style={styles.logo} />

                <p style={styles.brandDesc}>
                  {Contact.description ||
                    "Hyderabad's most celebrated private theatre experience — where every moment becomes a memory worth keeping."}
                </p>

                {/* Social row */}
                <div style={styles.socialRow}>
                  {[
                    { href: "https://www.facebook.com/carnivalcastlehyderabad?_rdr", icon: <FaFacebookF />, label: "Facebook" },
                    { href: "https://www.youtube.com/@Carnival_Castle",              icon: <FaYoutube />,    label: "YouTube"  },
                    { href: "https://www.instagram.com/carnival_castle_/",  icon: <FaInstagram />,  label: "Instagram"},
                    { href: `https://wa.me/${Contact.phone}`,                        icon: <FaWhatsapp />,   label: "WhatsApp" },
                  ].map(({ href, icon, label }) => (
                    <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                      aria-label={label} style={styles.socialIcon}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = C.gold;
                        e.currentTarget.style.color      = C.ink;
                        e.currentTarget.style.transform  = "translateY(-3px)";
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = C.goldDim;
                        e.currentTarget.style.color      = C.gold;
                        e.currentTarget.style.transform  = "translateY(0)";
                      }}>
                      {icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* ── Col 2: Quick Links ────────────────────── */}
            <div className="col-lg-2 col-md-6 col-6">
              <div style={styles.colWrap}>
                <ColTitle>Quick Links</ColTitle>
                <ul style={styles.linkList}>
                  {quickLinks.map(({ to, label }) => (
                    <li key={to} style={{ marginBottom: 10 }}>
                      <NavLink to={to} style={styles.navLink}
                        onMouseEnter={e => {
                          e.currentTarget.style.color       = C.gold;
                          e.currentTarget.style.paddingLeft = "10px";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.color       = C.offWhite;
                          e.currentTarget.style.paddingLeft = "0";
                        }}>
                        <span style={styles.linkArrow}>›</span>
                        {label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* ── Col 3: Contact ────────────────────────── */}
            <div className="col-lg-5 col-md-12">
              <div style={styles.colWrap}>
                <ColTitle>Get In Touch</ColTitle>

                <div style={styles.contactBlock}>
                  <ContactItem icon="fa-solid fa-location-dot">
                    {Contact.address || "Hyderabad, Telangana, India"}
                  </ContactItem>
                  <ContactItem icon="fa-solid fa-phone">
                    <a href={`tel:+91${Contact.phone}`} style={styles.contactLink}>
                      +91 {Contact.phone}
                      <span style={{ color: C.muted, fontSize: 11, marginLeft: 6 }}>(WhatsApp only)</span>
                    </a>
                  </ContactItem>
                  <ContactItem icon="fa-solid fa-envelope">
                    <a href={`mailto:${Contact.email}`} style={styles.contactLink}>
                      {Contact.email}
                    </a>
                  </ContactItem>
                </div>

                {/* CTA chip */}
                <a href={`https://wa.me/${Contact.phone}`} target="_blank" rel="noopener noreferrer"
                  style={styles.ctaChip}
                  onMouseEnter={e => { e.currentTarget.style.background = C.gold; e.currentTarget.style.color = C.ink; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.gold; }}>
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 16 }} />
                  Book on WhatsApp
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Gold divider ── */}
      <div style={styles.divider} />

      {/* ═══════════════════════════════════════════════
          FOOTER BOTTOM
      ═══════════════════════════════════════════════ */}
      <div style={styles.bottom}>
        <div className="container-md">
          <div style={styles.bottomInner}>

            {/* Policy links */}
            <div style={styles.policyRow}>
              {policies.map(({ to, label }, i) => (
                <React.Fragment key={to}>
                  <NavLink to={to} style={styles.policyLink}
                    onMouseEnter={e => e.currentTarget.style.color = C.gold}
                    onMouseLeave={e => e.currentTarget.style.color = C.muted}>
                    {label}
                  </NavLink>
                  {i < policies.length - 1 && (
                    <span style={{ color: C.divider, margin: "0 10px" }}>|</span>
                  )}
                </React.Fragment>
              ))}
            </div>

            {/* Copyright */}
            <p style={styles.copyright}>
              © {new Date().getFullYear()}&nbsp;
              <span style={{ color: C.gold, fontWeight: 700 }}>Carnival Castle</span>.
              &nbsp;All Rights Reserved.
            </p>

          </div>
        </div>
      </div>

      <Styles />
    </footer>
  );
}

// ── Small helpers ─────────────────────────────────────────────────────────────

const ColTitle = ({ children }) => (
  <div style={{ marginBottom: 24 }}>
    <h3 style={{
      fontFamily: "'Playfair Display', serif",
      fontSize: 18, fontWeight: 800, color: C.white,
      margin: "0 0 10px", letterSpacing: 0.4,
    }}>
      {children}
    </h3>
    <div style={{ width: 36, height: 2, background: `linear-gradient(90deg, ${C.gold}, transparent)` }} />
  </div>
);

const ContactItem = ({ icon, children }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 18 }}>
    <div style={{
      width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
      background: C.goldDim, border: `1px solid ${C.goldBorder}`,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <i className={icon} style={{ color: C.gold, fontSize: 14 }} />
    </div>
    <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13.5,
      color: C.offWhite, lineHeight: 1.6, paddingTop: 6 }}>
      {children}
    </div>
  </div>
);

// ── Inline styles ─────────────────────────────────────────────────────────────

const styles = {
  footer: {
    background: `linear-gradient(175deg, ${C.purpleMid} 0%, ${C.purple} 45%, ${C.ink} 100%)`,
    position: "relative",
    overflow: "hidden",
    fontFamily: "'DM Sans', sans-serif",
  },
  topBorder: {
    height: 2,
    background: `linear-gradient(90deg, transparent 0%, ${C.gold} 30%, ${C.goldLight} 50%, ${C.gold} 70%, transparent 100%)`,
  },
  goldAccent: {
    height: 3,
    width: "100%",
    background: `linear-gradient(135deg, ${C.gold}, ${C.goldLight}, ${C.gold}, #DAA520, #B8860B)`,
    marginBottom: 0,
  },
  glowLeft: {
    position: "absolute", top: 0, left: "-10%",
    width: 500, height: 500, borderRadius: "50%",
    background: "radial-gradient(circle, rgba(157,77,255,0.18) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  glowRight: {
    position: "absolute", bottom: 0, right: "-10%",
    width: 400, height: 400, borderRadius: "50%",
    background: "radial-gradient(circle, rgba(255,215,0,0.08) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  body: {
    padding: "64px 0 48px",
    position: "relative", zIndex: 1,
  },
  brandCol: {
    display: "flex", flexDirection: "column", gap: 0,
  },
  logo: {
    height: 90, objectFit: "contain", objectPosition: "left",
    marginBottom: 20,
  },
  brandDesc: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 13.5, color: C.muted, lineHeight: 1.75,
    maxWidth: 360, marginBottom: 24,
  },
  socialRow: {
    display: "flex", gap: 10,
  },
  socialIcon: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    background: C.goldDim,
    border: `1px solid ${C.goldBorder}`,
    color: C.gold,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 17,
    textDecoration: "none",
    transition: "all 0.25s ease",
  },
  colWrap: {
    paddingTop: 4,
  },
  linkList: {
    listStyle: "none", margin: 0, padding: 0,
  },
  navLink: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 13.5, color: C.offWhite,
    textDecoration: "none", display: "flex",
    alignItems: "center", gap: 8,
    transition: "all 0.2s ease",
  },
  linkArrow: {
    color: C.gold, fontSize: 18, lineHeight: 1, flexShrink: 0,
  },
  contactBlock: {
    marginBottom: 24,
  },
  contactLink: {
    color: C.offWhite, textDecoration: "none",
    transition: "color 0.2s",
  },
  ctaChip: {
    display: "inline-flex", alignItems: "center",
    padding: "10px 22px", borderRadius: 30,
    border: `1.5px solid ${C.gold}`,
    color: C.gold, background: "transparent",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 13, fontWeight: 700,
    letterSpacing: 0.5, textDecoration: "none",
    transition: "all 0.25s ease",
    gap: 8,
  },
  divider: {
    height: 1,
    background: `linear-gradient(90deg, transparent, ${C.goldBorder} 30%, ${C.goldBorder} 70%, transparent)`,
    margin: "0 24px",
  },
  bottom: {
    padding: "20px 0",
    position: "relative", zIndex: 1,
  },
  bottomInner: {
    display: "flex", flexWrap: "wrap",
    alignItems: "center", justifyContent: "space-between",
    gap: 12,
  },
  policyRow: {
    display: "flex", flexWrap: "wrap",
    alignItems: "center", gap: 2,
  },
  policyLink: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12, color: C.muted,
    textDecoration: "none",
    transition: "color 0.2s ease",
    whiteSpace: "nowrap",
  },
  copyright: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12.5, color: C.muted,
    margin: 0,
  },
};

// ── Global micro-styles ───────────────────────────────────────────────────────
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=DM+Sans:wght@400;500;700&display=swap');
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

    footer a:hover { text-decoration: none !important; }

    @media (max-width: 767px) {
      .footer-bottom-inner { flex-direction: column; text-align: center; }
    }
  `}</style>
);

export default Footer;